import type { APIAuthUserResponse, APIUserResponse, APIUserSsnStatusResponse } from './types';
import { paymentUsersInstance, usersInstance } from './users-instance';

// Returns user email
export const me = async (accessToken?: string): Promise<APIAuthUserResponse> => {
  const response = await usersInstance.get(
    '/universal-auth/me',
    accessToken
      ? {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      : undefined
  );

  if (typeof window !== 'undefined' && !!window.sessionStorage) {
    sessionStorage.setItem('user', JSON.stringify(response.data.data));
  }
  return response.data;
};

export type IntercomWebJwt = { jwt: string; expiresAt: number };

// Fresh Messenger Security JWT for the web Messenger. Deliberately does not touch the
// sessionStorage copy of the user that `me()` writes — that copy lives for the whole tab.
export const getIntercomWebJwt = async (): Promise<IntercomWebJwt | null> => {
  const response = await usersInstance.get<APIAuthUserResponse>('/universal-auth/me');
  const identity = response.data.data.intercomIdentity;

  if (!identity?.jwt?.web || !identity.jwtExpiresAt) {
    return null;
  }
  return { jwt: identity.jwt.web, expiresAt: identity.jwtExpiresAt };
};

// Returns name, address, verification status and current timeouts
export const meDetailed = async (): Promise<APIUserResponse> => {
  const response = await paymentUsersInstance.get('/users/me');
  return response.data;
};

interface InviteUsersPayload {
  inviteLink: string;
  contestId: string;
  // Splash
  userIds?: string[];
  contestIds?: string[];
  // RYP
  rypUserIds?: string[];
  rypPoolIds?: string[];
  // Email
  emails?: string[];
  // OFP
  ofpUserIds?: string[];
  ofpContestIds?: string[];
  customMessage?: string;
  from?: string;
}

export const sendInvites = async (payload: InviteUsersPayload) => {
  const response = await usersInstance.post('/invite/contest', payload);
  return response.data;
};

export const getUserSsnStatus = async (): Promise<APIUserSsnStatusResponse> => {
  const response = await paymentUsersInstance.get('/user-ssns/status');
  return response.data;
};

type UserSsnPayload = {
  ssn: string;
};

export const postUserSsn = async (payload: UserSsnPayload) => {
  const response = await paymentUsersInstance.post('/user-ssns', payload);

  return response.data;
};
